import { create } from 'zustand';
import createAxiosInstance from '../services/global/axiosInstance';
import errorHandler from '../utils/error-handler.util';
import { IApiResponse } from '../models/resource.model';
import { IActiveCountry, ICurrencyPairRate } from '../models/rate.model';
import { getFlagUrl } from '../utils/flag.util';

const axiosInstance = createAxiosInstance();

export interface IRateStore {
  loading: boolean;
  currencyPairRate: ICurrencyPairRate | null;
  getCurrencyPairRate: (
    fromCurrency: string,
    toCurrency: string,
  ) => Promise<IApiResponse | null>;
  activeCountries: IActiveCountry[];
  getActiveCountries: () => Promise<IApiResponse | null>;
}

const useRateStore = create<IRateStore>((set, get) => ({
  loading: false,
  transferCurrencies: [],
  currencyPairRate: null,
  getCurrencyPairRate: async (fromCurrency: string, toCurrency: string) => {
    try {
      const response = await axiosInstance.get(
        `/exchangerates/${fromCurrency}/${toCurrency}`,
      );
      set({
        currencyPairRate: response?.data.value.value,
      });
      return response?.data.value;
    } catch (err: any) {
      errorHandler(err);
    }
  },
  activeCountries: [],
  getActiveCountries: async () => {
    try {
      const response = await axiosInstance.get(
        `/exchangerates/active-countries`,
      );
      set({
        activeCountries: response?.data.value.value.map(
          (country: IActiveCountry) => {
            return { ...country, flagUrl: getFlagUrl(country.name) };
          },
        ),
      });
      return response?.data.value;
    } catch (err: any) {
      errorHandler(err);
    }
  },
}));

export default useRateStore;
